import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../../common/TitleSection';
import styles from "../../../../ContentStyling.module.css";

const CmToInches = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToInches = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 10, 25.4).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const inchesValue = cmValue / 2.54; // 1 inch = 2.54 cm
        setOutputValue(inchesValue.toFixed(6)); // Limit output to 6 decimal places
    };


      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/inches-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to Inches Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to Inches using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
                icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                title="CM To Inches Converter"
                subTitle="Effortlessly Convert CM To Inches for Accurate Measurements"
              />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToInches}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Inches Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For designers, engineers, students, and anyone handling measurements, the CM to Inches Converter is an essential tool. It helps you convert values from centimeters (CM), the metric standard, to inches (IN), the imperial unit, making it ideal for international projects, product specs, and academic needs.</p>
      <p>This converter ensures that your measurements are accurate and compatible with regional standards whether you're designing a physical product, resizing a graphic layout, or preparing blueprints.</p>
      <h3>What Are CM and Inches?</h3>
      <p><b>Centimeters (CM): </b> A unit of length in the metric system. 1 centimeter equals 0.01 meters. Widely used in most parts of the world for measuring objects, distances, and more.</p>
      <p><b>Inches (IN): </b> A unit of length in the imperial system, primarily used in the United States. 1 inch equals 2.54 centimeters. Commonly used in construction, design, and manufacturing.</p>
      <h3>Why Convert CM to Inches?</h3>
      <ul>
        <li><b>International Compatibility: </b>Convert metric measurements to imperial units for use in U.S.-based projects or collaborations.</li>
        <li><b>Standardization: </b>Useful for publishing specs, eCommerce listings, or packaging that follow inch-based measurements.</li>
        <li><b>Accuracy: </b>Prevents errors when switching between different measurement systems.</li>
      </ul>
      <h3>How to Use the CM to Inches Converter</h3>
      <ol>
        <li><b>Input CM Value: </b> Enter the centimeter value into the designated field.</li>
        <li><b>Click Convert: </b> The tool will instantly calculate and display the equivalent value in inches.</li>
        <li><b>Use the Result: </b> Copy the converted inch value for your documentation, designs, or specs.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 cm → 0.39 in</li>
        <li>10 cm → 3.94 in</li>
        <li>50 cm → 19.69 in</li>
        <li>100 cm → 39.37 in</li>
      </ul>
      <h3>Benefits of Using CM to Inches Converter</h3>
      <ul>
        <li><b>User-Friendly:</b> No math required just enter, click, and convert.</li>
        <li><b>Precise:</b> Delivers accurate results using the exact conversion factor (1 inch = 2.54 cm).</li>
        <li><b>Fast & Efficient:</b> Ideal for professionals who work under time constraints.</li>
      </ul>
      <h3>Why Choose This CM to Inches Converter?</h3>
      <p>This tool is designed for everyone, from students working on science assignments to professionals preparing technical documents. It’s advantageous for:</p>
      <ul>
        <li><b>Engineers & Architects:</b> For converting metric blueprints to imperial systems.</li>
        <li><b>eCommerce Sellers:</b> To display size details that appeal to international customers.</li>
        <li><b>DIYers & Hobbyists:</b> For understanding and applying global measurement standards.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToInches;
